import * as React from 'react';
export const refreshSvg = React.forwardRef(function refreshSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 8c0-3.514 2.866-5.75 5.75-5.75 2.402 0 4.519 1.577 5.095 4.25H9a.875.875 0 1 0 0 1.75h5.875a.875.875 0 0 0 .875-.875V1.5a.875.875 0 0 0-1.75 0v2.997C12.821 1.994 10.395.5 7.75.5 4.034.5.25 3.39.25 8c0 4.61 3.784 7.45 7.5 7.45 1.98 0 3.856-.733 5.286-2.164A.875.875 0 1 0 11.8 12.05c-1.1 1.097-2.53 1.7-4.05 1.7C4.866 13.75 2 11.514 2 8Z',
    }),
  );
});
refreshSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var refresh = {
  category: 'icon',
  colorable: true,
  name: 'refresh',
  svg: refreshSvg,
};
